
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import {
  BarChart3,
  Users,
  Settings,
  Shield,
  Clock,
  GraduationCap,
  Home
} from 'lucide-react';
import { cn } from '@/lib/utils';

interface MenuItem {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  href: string;
}

const AdminSidebar = () => {
  const { t } = useLanguage();
  const location = useLocation();

  const menuItems: MenuItem[] = [
    {
      icon: BarChart3,
      label: t('dashboard', 'لوحة التحكم', 'Dashboard'),
      href: '/admin'
    },
    {
      icon: Clock,
      label: t('listings_approval', 'موافقة الإعلانات', 'Listings Approval'),
      href: '/admin/listings'
    },
    {
      icon: Home,
      label: t('listings_management', 'إدارة الإعلانات', 'Listings Management'),
      href: '/admin/listings-management'
    },
    {
      icon: Users,
      label: t('users', 'المستخدمين', 'Users'),
      href: '/admin/users'
    },
    {
      icon: GraduationCap,
      label: t('universities', 'الجامعات', 'Universities'),
      href: '/admin/universities'
    },
    {
      icon: Shield,
      label: t('kyc_verification', 'التحقق من الهوية', 'KYC Verification'),
      href: '/admin/kyc'
    },
    {
      icon: Settings,
      label: t('settings', 'الإعدادات', 'Settings'),
      href: '/admin/settings'
    }
  ];

  return (
    <div className="w-64 flex-shrink-0 border-r border-gray-200 bg-white shadow-sm h-full">
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-xl font-bold text-gray-900">
          {t('admin_panel', 'لوحة الإدارة', 'Admin Panel')}
        </h2>
      </div>
      <nav className="flex flex-col space-y-2 p-4">
        {menuItems.map((item) => (
          <Link
            key={item.label}
            to={item.href}
            className={cn(
              "flex items-center space-x-3 rounded-lg p-3 transition-all duration-200",
              location.pathname === item.href 
                ? "bg-primary text-white font-semibold shadow-sm" 
                : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
            )}
          >
            <item.icon className={cn(
              "h-5 w-5 flex-shrink-0",
              location.pathname === item.href 
                ? "text-white" 
                : "text-gray-500"
            )} />
            <span className="text-sm font-medium">{item.label}</span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default AdminSidebar;
